import { useEffect, useState } from "react";
import { Trophy, Gift } from "@phosphor-icons/react";
import client from "../lib/api";

export default function HeaderRewardsChip({ onRedeem }) {
  const [d, setD] = useState(null);
  useEffect(() => { client.get("/rewards/me").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || d.cash_value == null) return null;
  return (
    <button data-testid="header-rewards-chip" onClick={onRedeem} title="View your rewards & redeem points"
      className="group flex items-center gap-2.5 rounded-[5px] border border-[#B08D57]/40 bg-white hover:bg-white/70 pl-3 pr-1.5 py-1.5 transition-colors shadow-[0_2px_10px_rgba(74,0,0,0.05)]">
      <Trophy size={16} weight="fill" className="text-[#B08D57] shrink-0" />
      <span className="text-sm leading-none whitespace-nowrap">
        <span className="font-mono tabular-nums font-semibold text-[#4A0000]" data-testid="header-rewards-points">{d.points.toLocaleString()}</span>
        <span className="text-[#9A968E]"> pts</span>
        <span className="text-[#8a6d0a] font-semibold"> · ${d.cash_value.toFixed(2)}</span>
      </span>
      <span data-testid="header-rewards-redeem"
        className="ml-1 inline-flex items-center gap-1 rounded-[4px] bg-[#4A0000] group-hover:bg-[#5C1A1A] text-white text-xs font-medium px-2.5 py-1 transition-colors">
        <Gift size={13} weight="fill" />Redeem
      </span>
    </button>
  );
}
